class PermissionService {
  flattenObject = (permissionObj) => {
    const p = Object.keys(permissionObj || {})
      ?.map((key) => {
        const _permis = [];
        if (permissionObj[key]) _permis.push(key);
        return _permis;
      })
      .filter(Boolean);

    console.log('permissions', p);

    return p;
  };
}

export default new PermissionService();
